import PropTypes from "prop-types";

export const groupTypes = PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    description: PropTypes.string,
    player: PropTypes.arrayOf(
        PropTypes.shape({
            avatar: PropTypes.shape({
                url: PropTypes.string,
            }),
            family_name: PropTypes.string,
            full_name: PropTypes.string,
            id: PropTypes.number,
            name: PropTypes.string,
        })
    ),
});
